import React from 'react'
import { useAppSelector } from 'src/app/hooks'
import { CustomTitle } from 'src/components'
import { getFormatedPrice } from 'src/core/helpers'
import { AdminTransfer } from 'src/core/models'
import { currencyListSelector } from 'src/features'

const TransferTotalColumn: React.FC<{ transfer: AdminTransfer }> = ({ transfer }) => {
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === transfer.order.currency_token)?.code || 'EUR'
  const label = `${getFormatedPrice(transfer.order.total, currencyCode)} - ${currencyCode}`

  return <CustomTitle type={null} label={label} />
}

export default TransferTotalColumn
